export default class ShopifyAdmin {
  static prefix = 'admin/'
}
